import {LabSubmissionStatusEnum} from '#apollo/schema';
import {sprinkles} from '#style/sprinkles';

import {LeftTile, RightTile} from './components';
import {getTrackingTilesProps} from './SetTracker.utils';

import {SetTrackerProps} from './SetTracker.types';

/**
 * This component corresponds to the "Tracker Set" group of cards rendered on
 * the Dashboard page, as defined in Figma, here:
 *
 * - https://www.figma.com/file/0FC3zHUvT3UkQJ4snKJsm7/Fast-Follows?node-id=5127-162888
 *
 * This set generally displays data for the processing status of a registered kit,
 * when available.
 */
export const SetTracker = ({labSubmissions = [], mostRecentLabSubmission}: SetTrackerProps) => {
  const {leftTileProps, rightTileProps} = getTrackingTilesProps({
    labSubmissions,
    mostRecentLabSubmission,
  });
  const isResultsReady =
    Boolean(labSubmissions?.length) &&
    mostRecentLabSubmission?.status === LabSubmissionStatusEnum.Ready;

  if (isResultsReady) return null;

  return (
    <div
      className={sprinkles({
        colSpan: [8, 12],
        cols: [4, 12],
        display: 'grid',
        gap: [0, 0, 24],
      })}>
      <LeftTile {...leftTileProps} />
      <RightTile {...rightTileProps} />
    </div>
  );
};
